export default __webpack_public_path__ + "static/media/8.1e06b5a2.jpg";